interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onSelect: (page: number) => void;
}

export default function Pagination({ currentPage, totalPages, onSelect }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  const start = Math.max(1, Math.min(currentPage - 2, totalPages - 4));
  const end = Math.min(totalPages, start + 4);
  for (let i = start; i <= end; i += 1) pages.push(i);

  const baseBtn =
    "flex items-center justify-center min-w-9 h-9 px-2 rounded-md text-sm font-label whitespace-nowrap transition-colors disabled:opacity-40 disabled:cursor-not-allowed";

  return (
    <nav className="flex items-center justify-center gap-2 flex-wrap" aria-label="分页导航">
      <button
        type="button"
        className={`${baseBtn} bg-background-100 text-foreground-700 hover:bg-background-200`}
        onClick={() => onSelect(currentPage - 1)}
        disabled={currentPage <= 1}
      >
        <i className="ri-arrow-left-s-line" />
      </button>
      {start > 1 ? (
        <>
          <button type="button" className={`${baseBtn} bg-background-100 text-foreground-700 hover:bg-background-200`} onClick={() => onSelect(1)}>
            1
          </button>
          {start > 2 ? <span className="text-foreground-400">…</span> : null}
        </>
      ) : null}
      {pages.map((page) => (
        <button
          key={page}
          type="button"
          className={`${baseBtn} ${
            page === currentPage
              ? "bg-primary-500 text-background-50"
              : "bg-background-100 text-foreground-700 hover:bg-background-200"
          }`}
          onClick={() => onSelect(page)}
        >
          {page}
        </button>
      ))}
      {end < totalPages ? (
        <>
          {end < totalPages - 1 ? <span className="text-foreground-400">…</span> : null}
          <button type="button" className={`${baseBtn} bg-background-100 text-foreground-700 hover:bg-background-200`} onClick={() => onSelect(totalPages)}>
            {totalPages}
          </button>
        </>
      ) : null}
      <button
        type="button"
        className={`${baseBtn} bg-background-100 text-foreground-700 hover:bg-background-200`}
        onClick={() => onSelect(currentPage + 1)}
        disabled={currentPage >= totalPages}
      >
        <i className="ri-arrow-right-s-line" />
      </button>
    </nav>
  );
}